var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommentAuthor(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 28H1.16667C0.857248 28 0.560501 27.8771 0.341709 27.6583C0.122916 27.4395 0 27.1428 0 26.8333V14C0 12.1615 0.36212 10.341 1.06568 8.64241C1.76925 6.94386 2.80048 5.40051 4.1005 4.1005C5.40051 2.80048 6.94386 1.76925 8.64242 1.06568C10.341 0.362119 12.1615 -1.99838e-07 14 0H14C15.8385 0 17.659 0.362121 19.3576 1.06569C21.0561 1.76925 22.5995 2.80048 23.8995 4.1005C25.1995 5.40053 26.2307 6.94387 26.9343 8.64243C27.6379 10.341 28 12.1615 28 14V14C28 17.7131 26.525 21.274 23.8995 23.8995C21.274 26.525 17.7131 28 14 28Z",
    fill: "#0D1C49"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentAuthor);
export default __webpack_public_path__ + "static/media/comment-author.599b386755ea53184699c45b6e331070.svg";
export { ForwardRef as ReactComponent };